import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, Col, Container, Form, Row, Toast, ToastContainer, Modal, Alert, Image } from 'react-bootstrap';

import styles from './ChamadosNovo.module.css';
import { UserContext } from '../../context/UserContext';
import { listaSaudeMental, listaAtencaoBasica } from '../../helpers/listaMedicamentos';
import { listaMateriaisEscritorio } from '../../helpers/listaMateriaisEscritorio';
import { listaMateriaisExpediente } from '../../helpers/listaMateriaisExpediente';
import { listaMateriaisLimpeza } from '../../helpers/listaMateriaisLimpeza';
import { cpfMask, matriculaMask, phoneMask } from '../../helpers/masks';
import SuporteTi from '../../components/SuporteTi';
import ManutencaoPredial from '../../components/ManutencaoPredial';
import ManutencaoEquip from '../../components/ManutencaoEquip';
import Reposicao from '../../components/Reposicao';
import Veiculo from '../../components/Veiculo';
import Unidades from '../../components/Unidades';
import Relato from '../../components/Relato';
import Categorias from '../../components/Categorias';
import Email from '../../components/Email';
import MedicamentosSaudeMental from '../../components/MedicamentosSaudeMental';
import MedicamentosAtencaoBasica from '../../components/MedicamentosAtencaoBasica';
import SolicitacaoVeiculo from '../../components/SolicitacaoVeiculo';
import MateriaisEscritorio from '../../components/MateriaisEscritorio';
import MateriaisExpediente from '../../components/MateriaisExpediente';
import MateriaisLimpeza from '../../components/MateriaisLimpeza';
import Eletrica from '../../components/Eletrica';
import Hidrossanitario from '../../components/Hidrossanitario';
import Mecanica from '../../components/Mecanica';
import criarChamado from '../../api/criarChamado';
import getUnidades from '../../api/getUnidades';
import getCategorias from '../../api/getCategorias';
import { decrypt } from '../../helpers/cryptography';
import SolicitacaoMotoboy from '../../components/SolicitacaoMotoboy';
import Demonstrativos from '../../components/Demonstrativos';
import ValeRefeicao from '../../components/ValeRefeicao';
import updateValeRefeicao from '../../api/updateValeRefeicao';
import getUserByEmail from '../../api/getUserByEmail';
import Vestuario from '../../components/Vestuario';
import Cadastro from '../../components/Cadastro';
import updateVestuario from '../../api/updateVestuario';
import LoginSistemas from '../../components/LoginSistemas';
import SuporteSistemas from '../../components/SuporteSistemas';
import formatarMatricula from '../../helpers/formatarMatricula';
import Votacao from '../../components/Votacao';
import EngenhariaClinica from '../../components/EngenhariaClinica';
import ManutencaoEquipamentos from '../../components/ManutencaoEquipamentos';
import equipamentosEngenhariaClinica from '../../helpers/equipamentosEngenhariaClinica';
import Ascom from '../../components/Ascom';
import Briefing from '../../components/Briefing';
import getExtension from '../../helpers/getExtension';
import briefingSupportedExtensions from '../../helpers/briefingSupportedExtensions';
import Erp from '../../components/Erp/index';
import baseUrl from '../../api/baseUrl';
import unidadesPesquisa from '../../helpers/unidadesPesquisa';
import { cnsValidator, cpfValidator, emailValidator } from '../../helpers/validators';
import extensoesSuporte from '../../helpers/extensoesSuporte';
import PontoEletronico from '../../components/PontoEletronico';
import { pontoEletronicoSelect } from '../../helpers/chamadosSelect';
import formatarDataEHora from '../../helpers/formatarDataEHora';
import getCipaInscricao from '../../api/getCipaInscricao';
import getCipaJaVotou from '../../api/getCipaJaVotou';
import CipaInscricao from '../../components/CipaInscricao';
import cipaCards from '../../helpers/cipaCards';
import criarCipa from '../../api/criarCipa';
import Cipa from '../../components/Cipa';
import { FaFileAlt } from 'react-icons/fa';
import SuporteTiForm from '../../components/SuporteTiForm';

const ChamadosNovo = () => {
  const { isAdmin, isConsulta, isErp } = useContext(UserContext);
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [categoria, setCategoria] = useState('');
  const [subcategoria, setSubcategoria] = useState('');
  const [unidade, setUnidade] = useState('');
  const [matricula, setMatricula] = useState('');
  const [relato, setRelato] = useState('');
  const [counter, setCounter] = useState(0);
  const [usuario, setUsuario] = useState(null);
  const [userUnidade, setUserUnidade] = useState('');
  const [userNome, setUserNome] = useState('');
  const [userTelefone, setUserTelefone] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userMatricula, setUserMatricula] = useState('');
  const [isRequired, setIsRequired] = useState(true);
  const [mensagemRelato, setMensagemRelato] = useState('*Descreva brevemente a solicitação:');
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unidades, setUnidades] = useState([]);
  const [valeRefeicao, setValeRefeicao] = useState('');
  const [showModalVRErro, setShowModalVRErro] = useState(false);
  const [showModalVRConfirm, setShowModalVRConfirm] = useState(false);
  const [vrOption, setVrOption] = useState('');
  const [isValeRefeicao, setIsValeRefeicao] = useState(false);
  const [isVestuario, setIsVestuario] = useState(false);
  const [mostrarVestuario, setMostrarVestuario] = useState(true);
  const prazoInscricao = true;
  const prazoVotacao = false;

  const medicamentosInitial = {
    medicamento: '',
    quantidade: '1'
  };

  const materiaisInitial = {
    material: '',
    quantidade: '1'
  };

  const [medicamentosSaudeMental, setMedicamentosSaudeMental] = useState([medicamentosInitial]);
  const [medicamentosAtencaoBasica, setMedicamentosAtencaoBasica] = useState([medicamentosInitial]);
  const [materiaisEscritorio, setMateriaisEscritorio] = useState([materiaisInitial]);
  const [materiaisExpediente, setMateriaisExpediente] = useState([materiaisInitial]);
  const [materiaisLimpeza, setMateriaisLimpeza] = useState([materiaisInitial]);
  const [showMedicamentosAtencaoBasica, setShowMedicamentosAtencaoBasica] = useState(false);
  const [materialError, setMaterialError] = useState('');
  const [relatoError, setRelatoError] = useState('');
  const [showRelatoModal, setShowRelatoModal] = useState(false);

  const solicitacaoVeiculoInitialState = {
    veiculoData: '',
    veiculoHora: '',
    veiculoTempo: '',
    veiculoPassageiro: '',
    veiculoTelefone: '',
    veiculoMotivo: '',
    veiculoSaida: '',
    veiculoDestino: ''
  };

  const solicitacaoMotoboyInitialState = {
    motoboyData: '',
    motoboyHora: '',
    motoboyTempo: '',
    motoboyPassageiro: '',
    motoboyTelefone: '',
    motoboyMotivo: '',
    motoboySaida: '',
    motoboyDestino: ''
  };

  const createEmailInitialState = {
    registration: '',
    name: '',
    email: '',
    phone: '',
    admissionDate: '',
    unit: '',
    job: '',
    sisged: true
  };

  const loginSuporteInitialState = {
    tipo: '',
    unidade: '',
    nome: '',
    cpf: '',
    cns: '',
    email: '',
    telefone: ''
  };

  const [solicitacaoVeiculo, setSolicitacaoVeiculo] = useState(solicitacaoVeiculoInitialState);
  const [solicitacaoMotoboy, setSolicitacaoMotoboy] = useState(solicitacaoMotoboyInitialState);
  const [createEmail, setCreateEmail] = useState(createEmailInitialState);

  const [veiculoError, setVeiculoError] = useState('');

  const [numeroCalcado, setNumeroCalcado] = useState('');
  const [calcado, setCalcado] = useState('');
  const [vestuarioError, setVestuarioError] = useState('');
  const [showVestuarioModal, setShowVestuarioModal] = useState(false);
  const [camisa, setCamisa] = useState('');
  const [calca, setCalca] = useState('');
  const [jaleco, setJaleco] = useState('');
  const [vestuarioObservacoes, setVestuarioObservacoes] = useState('');
  const [showVestuarioToast, setShowVestuarioToast] = useState(false);
  const [showModalVestuarioConfirm, setShowModalVestuarioConfirm] = useState(false);
  const [showVestuarioMessageModal, setShowVestuarioMessageModal] = useState(true);

  const [loginSistemas, setLoginSistemas] = useState('');
  const [loginSuporte, setLoginSuporte] = useState(loginSuporteInitialState);
  const [showLoginSistemasModal, setShowLoginSistemasModal] = useState(false);
  const [loginSistemasError, setLoginSistemasError] = useState('');

  const [showModal, setShowModal] = useState(false);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailError, setEmailError] = useState('');

  const [cipaVoto, setCipaVoto] = useState('');
  const [cipaFoto, setCipaFoto] = useState('');
  const [showCipaModal, setShowCipaModal] = useState(false);
  const [cipaError, setCipaError] = useState('');
  const [cipaJaVotou, setCipaJaVotou] = useState({});
  const [cipaInscricao, setCipaInscricao] = useState({});
  const [votarCipa, setVotarCipa] = useState(true);
  const [showConfirmarCipaModal, setShowConfirmarCipaModal] = useState(false);
  const [showCipaJaVotouModal, setShowCipaJaVotouModal] = useState(false);

  const [equipamentoEngenhariaClinica, setEquipamentoEngenhariaClinica] = useState('');
  const [equipamentoEngenhariaClinicaError, setEquipamentoEngenhariaClinicaError] = useState('');
  const [showEquipamentoEngenhariaClinicaModal, setShowEquipamentoEngenhariaClinicaModal] = useState(false);

  const [briefingPorque, setBriefingPorque] = useState('');
  const [briefingMedidas, setBriefingMedidas] = useState('');
  const [briefingOnde, setBriefingOnde] = useState('');
  const [briefingArquivo1, setBriefingArquivo1] = useState(null);
  const [briefingArquivo2, setBriefingArquivo2] = useState(null);
  const [briefingArquivo3, setBriefingArquivo3] = useState(null);
  const [briefingArquivo4, setBriefingArquivo4] = useState(null);
  const [briefingArquivo5, setBriefingArquivo5] = useState(null);
  const [briefingPrazo, setBriefingPrazo] = useState('');
  const [briefingDetalhe, setBriefingDetalhe] = useState('');
  const [showBriefingModal, setShowBriefingModal] = useState(false);
  const [briefingError, setBriefingError] = useState('');

  const [suporteArquivo1, setSuporteArquivo1] = useState(null);
  const [suporteArquivo2, setSuporteArquivo2] = useState(null);
  const [suporteArquivo3, setSuporteArquivo3] = useState(null);
  const [suporteArquivo4, setSuporteArquivo4] = useState(null);
  const [suporteArquivo5, setSuporteArquivo5] = useState(null);
  const [showSuporteModal, setShowSuporteModal] = useState(false);
  const [suporteError, setSuporteError] = useState('');

  const [erpNome, setErpNome] = useState('');
  const [erpEmail, setErpEmail] = useState('');
  const [erpMatricula, setErpMatricula] = useState('');
  const [erpUnidade, setErpUnidade] = useState('');
  const [erpAdministrador, setErpAdministrador] = useState('0 - Sem acesso');
  const [erpCadastrosComuns, setErpCadastrosComuns] = useState('0 - Sem acesso');
  const [erpCadastrosComumFinanceiro, setErpCadastrosComumFinanceiro] = useState('0 - Sem acesso');
  const [erpGestaoDeProcessos, setErpGestaoDeProcessos] = useState('0 - Sem acesso');
  const [erpCompras, setErpCompras] = useState('0 - Sem acesso');
  const [erpContratoCompras, setErpContratoCompras] = useState('0 - Sem acesso');
  const [erpContasPagar, setErpContasPagar] = useState('0 - Sem acesso');
  const [erpPagamentoEscritural, setErpPagamentoEscritural] = useState('0 - Sem acesso');
  const [erpContasReceber, setErpContasReceber] = useState('0 - Sem acesso');
  const [erpTesouraria, setErpTesouraria] = useState('0 - Sem acesso');
  const [erpIntegracaoPadrao, setErpIntegracaoPadrao] = useState('0 - Sem acesso');
  const [erpContabil, setErpContabil] = useState('0 - Sem acesso');
  const [erpEstoque, setErpEstoque] = useState('0 - Sem acesso');
  const [erpPatrimonio, setErpPatrimonio] = useState('0 - Sem acesso');
  const [erpOrcamento, setErpOrcamento] = useState('0 - Sem acesso');
  const [erpReinf, setErpReinf] = useState('0 - Sem acesso');
  const [erpEfd, setErpEfd] = useState('0 - Sem acesso');
  const [erpEcd, setErpEcd] = useState('0 - Sem acesso');
  const [erpEcf, setErpEcf] = useState('0 - Sem acesso');
  const [showErpModal, setShowErpModal] = useState(false);
  const [erpError, setErpError] = useState('');

  const [telContatoTi, setTelContatoTi] = useState('');
  const [patrimonioTi, setPatrimonioTi] = useState('');
  const [showTiModal, setShowTiModal] = useState(false);
  const [tiError, setTiError] = useState('');

  const handleTiModalClose = () => setShowTiModal(false);

  const handleTelContatoTi = e => {
    setTelContatoTi(phoneMask(e.target.value));
  };

  const handlePatrimonioTi = e => setPatrimonioTi(e.target.value);

  const [pontoEletronico, setPontoEletronico] = useState('');
  const handlePontoEletronico = e => setPontoEletronico(e.target.value);
  
  const handleErpNome = e => setErpNome(e.target.value);
  const handleErpEmail = e => setErpEmail(e.target.value);
  const handleErpMatricula = e => {
    e.target.value = matriculaMask(e.target.value);

    setErpMatricula(e.target.value);
  };
  const handleErpUnidade = e => setErpUnidade(e.target.value);
  const handleErpAdministrador = e => setErpAdministrador(e.target.value);
  const handleErpCadastrosComuns = e => setErpCadastrosComuns(e.target.value);
  const handleErpCadastrosComumFinanceiro = e => setErpCadastrosComumFinanceiro(e.target.value);
  const handleErpGestaoDeProcessos = e => setErpGestaoDeProcessos(e.target.value);
  const handleErpCompras = e => setErpCompras(e.target.value);
  const handleErpContratoCompras = e => setErpContratoCompras(e.target.value);
  const handleErpContasPagar = e => setErpContasPagar(e.target.value);
  const handleErpPagamentoEscritural = e => setErpPagamentoEscritural(e.target.value);
  const handleErpContasReceber = e => setErpContasReceber(e.target.value);
  const handleErpTesouraria = e => setErpTesouraria(e.target.value);
  const handleErpIntegracaoPadrao = e => setErpIntegracaoPadrao(e.target.value);
  const handleErpContabil = e => setErpContabil(e.target.value);
  const handleErpEstoque = e => setErpEstoque(e.target.value);
  const handleErpPatrimonio = e => setErpPatrimonio(e.target.value);
  const handleErpOrcamento = e => setErpOrcamento(e.target.value);
  const handleErpReinf = e => setErpReinf(e.target.value);
  const handleErpEfd = e => setErpEfd(e.target.value);
  const handleErpEcd = e => setErpEcd(e.target.value);
  const handleErpEcf = e => setErpEcf(e.target.value);
  const handleErpModalClose = () => setShowErpModal(false);

  const handleBriefingPorque = e => setBriefingPorque(e.target.value);
  const handleBriefingMedidas = e => setBriefingMedidas(e.target.value);
  const handleBriefingOnde = e => setBriefingOnde(e.target.value);
  const handleBriefingPrazo = e => setBriefingPrazo(e.target.value);
  const handleBriefingDetalhe = e => setBriefingDetalhe(e.target.value);
  const handleBriefingModalClose = () => setShowBriefingModal(false);

  const handleSuporteModalClose = () => setShowSuporteModal(false);

  const handleBriefingArquivo = (e, ref) => {
    const nomeArquivo = ref.current.name;
    const extension = getExtension(e.target.files[0].name);

    if (!briefingSupportedExtensions.includes(extension)) {
      setBriefingError('Tipo de arquivo não suportado');
      setShowBriefingModal(true);

      e.target.value = null;

      if (nomeArquivo === 'briefingArquivo1') {
        setBriefingArquivo1(null);
      } else if (nomeArquivo === 'briefingArquivo2') {
        setBriefingArquivo2(null);
      } else if (nomeArquivo === 'briefingArquivo3') {
        setBriefingArquivo3(null);
      } else if (nomeArquivo === 'briefingArquivo4') {
        setBriefingArquivo4(null);
      } else if (nomeArquivo === 'briefingArquivo5') {
        setBriefingArquivo5(null);
      }

      return null;
    }

    if (e.target.files[0].size > 5242880) {
      setBriefingError('Arquivo excede o limite de 5MB');
      setShowBriefingModal(true);

      e.target.value = null;

      if (nomeArquivo === 'briefingArquivo1') {
        setBriefingArquivo1(null);
      } else if (nomeArquivo === 'briefingArquivo2') {
        setBriefingArquivo2(null);
      } else if (nomeArquivo === 'briefingArquivo3') {
        setBriefingArquivo3(null);
      } else if (nomeArquivo === 'briefingArquivo4') {
        setBriefingArquivo4(null);
      } else if (nomeArquivo === 'briefingArquivo5') {
        setBriefingArquivo5(null);
      }

      return null;
    }

    if (nomeArquivo === 'briefingArquivo1') {
      setBriefingArquivo1(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo2') {
      setBriefingArquivo2(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo3') {
      setBriefingArquivo3(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo4') {
      setBriefingArquivo4(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo5') {
      setBriefingArquivo5(e.target.files[0]);
    }
  };

  const resetBriefingArquivo = ref => {
    ref.current.value = null;

    const name = ref.current.name;

    if (name === 'briefingArquivo1') {
      setBriefingArquivo1(null);
    } else if (name === 'briefingArquivo2') {
      setBriefingArquivo2(null);
    } else if (name === 'briefingArquivo3') {
      setBriefingArquivo3(null);
    } else if (name === 'briefingArquivo4') {
      setBriefingArquivo4(null);
    } else if (name === 'briefingArquivo5') {
      setBriefingArquivo5(null);
    }
  };

  const handleSuporteArquivo = (e, ref) => {
    const nomeArquivo = ref.current.name;
    const extension = getExtension(e.target.files[0].name);

    if (!extensoesSuporte.includes(extension)) {
      setSuporteError('Tipo de arquivo não suportado');
      setShowSuporteModal(true);

      e.target.value = null;

      if (nomeArquivo === 'suporteArquivo1') {
        setSuporteArquivo1(null);
      } else if (nomeArquivo === 'suporteArquivo2') {
        setSuporteArquivo2(null);
      } else if (nomeArquivo === 'suporteArquivo3') {
        setSuporteArquivo3(null);
      } else if (nomeArquivo === 'suporteArquivo4') {
        setSuporteArquivo4(null);
      } else if (nomeArquivo === 'suporteArquivo5') {
        setSuporteArquivo5(null);
      }

      return null;
    }

    if (e.target.files[0].size > 5242880) {
      setSuporteError('Arquivo excede o limite de 5MB');
      setShowSuporteModal(true);

      e.target.value = null;

      if (nomeArquivo === 'suporteArquivo1') {
        setSuporteArquivo1(null);
      } else if (nomeArquivo === 'suporteArquivo2') {
        setSuporteArquivo2(null);
      } else if (nomeArquivo === 'suporteArquivo3') {
        setSuporteArquivo3(null);
      } else if (nomeArquivo === 'suporteArquivo4') {
        setSuporteArquivo4(null);
      } else if (nomeArquivo === 'suporteArquivo5') {
        setSuporteArquivo5(null);
      }

      return null;
    }

    if (nomeArquivo === 'suporteArquivo1') {
      setSuporteArquivo1(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo2') {
      setSuporteArquivo2(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo3') {
      setSuporteArquivo3(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo4') {
      setSuporteArquivo4(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo5') {
      setSuporteArquivo5(e.target.files[0]);
    }
  };

  const resetSuporteArquivo = ref => {
    ref.current.value = null;

    const name = ref.current.name;

    if (name === 'suporteArquivo1') {
      setSuporteArquivo1(null);
    } else if (name === 'suporteArquivo2') {
      setSuporteArquivo2(null);
    } else if (name === 'suporteArquivo3') {
      setSuporteArquivo3(null);
    } else if (name === 'suporteArquivo4') {
      setSuporteArquivo4(null);
    } else if (name === 'suporteArquivo5') {
      setSuporteArquivo5(null);
    }
  };

  const handleEquipamentoEngenhariaClinicaModalClose = () => setShowEquipamentoEngenhariaClinicaModal(false);

  const handleCipaModalClose = () => setShowCipaModal(false);
  const handleConfirmarCipaModalClose = () => setShowConfirmarCipaModal(false);
  const handleCipaJaVotouModalClose = () => setShowCipaJaVotouModal(false);

  const [cipaInscricaoUnidade, setCipaInscricaoUnidade] = useState('');
  const [cipaInscricaoCargo, setCipaInscricaoCargo] = useState('');
  const [cipaInscricaoSobre, setCipaInscricaoSobre] = useState('');
  const [showCipaInscricaoModal, setShowCipaInscricaoModal] = useState(false);
  const [cipaInscricaoError, setCipaInscricaoError] = useState('');

  const handleCipaInscricaoUnidade = e => setCipaInscricaoUnidade(e.target.value);
  const handleCipaInscricaoCargo = e => setCipaInscricaoCargo(e.target.value);
  const handleCipaInscricaoSobre = e => setCipaInscricaoSobre(e.target.checked);

  const handleCipaInscricaoModalClose = () => setShowCipaInscricaoModal(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleRelatoModalClose = () => setShowRelatoModal(false);
  const handleVestuarioModalClose = () => setShowVestuarioModal(false);
  const handleModalVestuarioConfirmClose = () => setShowModalVestuarioConfirm(false);
  const handleVestuarioMessageModalClose = () => setShowVestuarioMessageModal(false);
  const handleLoginSistemasModalClose = () => setShowLoginSistemasModal(false);

  const closeEmailModal = () => setShowEmailModal(false);

  const handleCreateEmail = e => {
    let { name, value } = e.target;

    if (name === 'phone') {
      e.target.value = phoneMask(e.target.value);
    }

    if (name === 'registration') {
      e.target.value = matriculaMask(e.target.value);
    }

    const list = { ...createEmail, [name]: value };

    setCreateEmail(list);
  };

  const handleAddMedicamentoSaudeMental = () => {
    setMedicamentosSaudeMental([...medicamentosSaudeMental, medicamentosInitial]);
  };

  const handleAddMedicamentoAtencaoBasica = () => {
    setMedicamentosAtencaoBasica([...medicamentosAtencaoBasica, medicamentosInitial]);
  };

  const handleAddMateriaisEscritorio = () => {
    setMateriaisEscritorio([...materiaisEscritorio, materiaisInitial]);
  };

  const handleAddMateriaisExpediente = () => {
    setMateriaisExpediente([...materiaisExpediente, materiaisInitial]);
  };

  const handleAddMateriaisLimpeza = () => {
    setMateriaisLimpeza([...materiaisLimpeza, materiaisInitial]);
  };

  const handleRemoveMedicamentoSaudeMental = index => {
    handleModalClose();

    let list = [...medicamentosSaudeMental];
    list.splice(index, 1);

    setMedicamentosSaudeMental(list);
  };

  const handleRemoveMedicamentoAtencaoBasica = index => {
    let list = [...medicamentosAtencaoBasica];
    list.splice(index, 1);

    setMedicamentosAtencaoBasica(list);
  };

  const handleRemoveMateriaisEscritorio = index => {
    let list = [...materiaisEscritorio];
    list.splice(index, 1);

    setMateriaisEscritorio(list);
  };

  const handleRemoveMateriaisExpediente = index => {
    let list = [...materiaisExpediente];
    list.splice(index, 1);

    setMateriaisExpediente(list);
  };

  const handleRemoveMateriaisLimpeza = index => {
    let list = [...materiaisLimpeza];
    list.splice(index, 1);

    setMateriaisLimpeza(list);
  };

  const handleMedicamentosSaudeMental = (position, field, item) => {
    const updatedMedicamentos = medicamentosSaudeMental.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMedicamentosSaudeMental(updatedMedicamentos);
  };

  const handleMedicamentosAtencaoBasica = (position, field, item) => {
    const updatedMedicamentos = medicamentosAtencaoBasica.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMedicamentosAtencaoBasica(updatedMedicamentos);
  };

  const handleMateriaisEscritorio = (position, field, item) => {
    const updatedMateriaisEscritorio = materiaisEscritorio.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMateriaisEscritorio(updatedMateriaisEscritorio);
  };

  const handleMateriaisExpediente = (position, field, item) => {
    const updatedMateriaisExpediente = materiaisExpediente.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMateriaisExpediente(updatedMateriaisExpediente);
  };

  const handleMateriaisLimpeza = (position, field, item) => {
    const updatedMateriaisLimpeza = materiaisLimpeza.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMateriaisLimpeza(updatedMateriaisLimpeza);
  };

  const handleSwitch = () => {
    setShowMedicamentosAtencaoBasica(!showMedicamentosAtencaoBasica);

    setMedicamentosAtencaoBasica([medicamentosInitial]);
  };

  const handleLoginSistemas = e => {
    setLoginSistemas(e.target.value);
  };

  const handleLoginSuporte = e => {
    let { name, value } = e.target;

    if (name === 'telefone') {
      e.target.value = phoneMask(e.target.value);
    }

    if (name === 'cpf') {
      e.target.value = cpfMask(e.target.value);
    }

    if (name === 'tipo') {
      setLoginSistemas('');
    }

    const list = { ...loginSuporte, [name]: value };

    setLoginSuporte(list);
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('login'));

    let exercicioDe;

    if (data?.user?.admissionDate) {
      const day = new Date(data?.user?.admissionDate).getUTCDate();
      const month = new Date(data?.user?.admissionDate).getUTCMonth();
      const actualYear = new Date().getUTCFullYear() - 1;
      exercicioDe = new Date(actualYear, month, day);
    }

    const exercicioA = new Date(exercicioDe);
    exercicioA.setDate(exercicioA.getDate() + 365);

    setUsuario(decrypt(data?.user?.name));
    setUserUnidade(decrypt(data?.user?.unit));
    setUserNome(decrypt(data?.user?.name));

    if (data?.user?.phone) {
      setUserTelefone(decrypt(data?.user?.phone));
      setTelefone(decrypt(data?.user?.phone));
    }

    if (data?.user?.registration) {
      setUserMatricula(decrypt(data?.user?.registration));
      setMatricula(decrypt(data?.user?.registration));
    }

    setUserEmail(decrypt(data?.user?.email));
    setEmail(decrypt(data?.user?.email));
    setNome(decrypt(data?.user?.name));
    setUnidade(decrypt(data?.user?.unit));
  }, []);

  useEffect(() => {
    const units = async () => {
      const response = await getUnidades('sisged');

      setUnidades(response);
    };

    units();
  }, []);

  useEffect(() => {
    const categories = async () => {
      let response = await getCategorias();

      if (isConsulta) {
        const categoriasConsulta = response.filter(categoria => categoria.id === 10 || categoria.id === 11 || categoria.id === 12);

        setCategorias(categoriasConsulta);

        return;
      }

      if (isConsulta) {
        const categoriasConsulta = response.filter(categoria => categoria.id === 7);

        setCategorias(categoriasConsulta);
      }

      if (!unidade.includes('Diretoria')) {
        const filterCategorias = response.filter(categoria => categoria.id !== 7 && categoria.id !== 9)

        setCategorias(filterCategorias);
      } else {
        setCategorias(response);
      }

      if (!unidade.includes('Diretoria')) {
        const filterCategorias = response.filter(categoria => categoria.id !== 7 && categoria.id !== 9);

        setCategorias(filterCategorias);
      }

      return response;
    };

    categories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unidade]);

  const handleEmail = e => {
    setEmail(e.target.value);
  };

  const handleNome = e => {
    setNome(e.target.value);
    setUserNome(e.target.value);
  };

  const handleTelefone = e => {
    const telMask = phoneMask(e.target.value);

    setTelefone(telMask);
    setUserTelefone(telMask);
  };

  const handleCategoria = e => {
    setCategoria(e.target.value);
    setSubcategoria('');
  };

  useEffect(() => {
    if (categoria === 'Reposição de Material/Estoque' || subcategoria === 'Criação de e-mail corporativo') {
      setIsRequired(false);
      setMensagemRelato('Observações:');
    } else {
      setIsRequired(true);
      setMensagemRelato('*Descreva brevemente a solicitação:');
    }
  }, [categoria, subcategoria]);

  const handleSubcategoria = e => {
    setSubcategoria(e.target.value);
  };

  const handleUnidade = e => {
    setUnidade(e.target.value);
    setUserUnidade(e.target.value);
  };

  const handleRelato = e => {
    let currentLength = e.target.value.length;

    setCounter(currentLength);
    setRelato(e.target.value);
  };

  const handleSolicitacaoVeiculo = e => {
    let { name, value } = e.target;

    if (name === 'veiculoTelefone') {
      e.target.value = phoneMask(e.target.value);
    }

    const list = { ...solicitacaoVeiculo, [name]: value };

    setSolicitacaoVeiculo(list);
  };

  const handleSolicitacaoMotoboy = e => {
    let { name, value } = e.target;

    if (name === 'motoboyTelefone') {
      e.target.value = phoneMask(e.target.value);
    }

    const list = { ...solicitacaoMotoboy, [name]: value };

    setSolicitacaoMotoboy(list);
  };

  useEffect(() => {
    if (subcategoria) {
      window.scrollBy(0, 350);
    }
  }, [subcategoria]);

  const handleValeRefeicao = e => {
    setValeRefeicao(e.target.value);
  };

  const handleModalVRErroClose = () => setShowModalVRErro(false);

  const handleModalVRConfirmClose = () => setShowModalVRConfirm(false);

  useEffect(() => {
    const getUser = async () => {
      const login = JSON.parse(localStorage.getItem('login'));
      const userEmail = login.user.email;
      const response = await getUserByEmail(userEmail);

      if (response?.valeRefeicao) {
        setIsValeRefeicao(response?.valeRefeicao);
      }

      if (response?.vestuario) {
        setIsVestuario(response?.vestuario);
        setShowVestuarioMessageModal(false);
      }

      if (response?.cipa) {
        setCipaJaVotou(response?.cipa);
      }

      if (response?.cipaInscricao) {
        setCipaInscricao(response?.cipaInscricao);
      }
    };

    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setVrOption(valeRefeicao);
  }, [valeRefeicao]);

  const vrConfirm = () => {
    setShowModalVRConfirm(false);

    const vrData = { email, valeRefeicao };

    updateValeRefeicao(vrData);

    history.push('/');
  };

  const vestuarioConfirm = async () => {
    setShowModalVestuarioConfirm(false);

    const vestuarioObj = {
      camisa,
      calca,
      jaleco,
      calcado,
      observacoes: vestuarioObservacoes
    };

    const vestuarioData = { email, vestuarioObj };

    updateVestuario(vestuarioData);

    setShowVestuarioToast(true);

    setTimeout(() => {
      history.push('/');
    }, 5000);
  };

  useEffect(() => {
    const getNumeroCalcado = Array.from({ length: 21 }, (v, k) => (k + 29) + 1);

    setNumeroCalcado(getNumeroCalcado);
  }, []);

  const handleCalcado = e => {
    setCalcado(e.target.value);
  };

  const handleCamisa = e => {
    setCamisa(e.target.value);
  };

  const handleCalca = e => {
    setCalca(e.target.value);
  };

  const handleJaleco = e => {
    setJaleco(e.target.value);
  };

  const handleVestuarioObservacoes = e => {
    setVestuarioObservacoes(e.target.value);
  };

  const selecionarCipa = e => {
    let childIndex = 5;

    if (isConsulta) {
      childIndex = 4;
    }

    [...e.target.form.childNodes[childIndex].children].forEach(node => node.firstChild.style.transform = 'scale(1)');
    [...e.target.form.childNodes[childIndex].children].forEach(node => node.firstChild.style.boxShadow = '9px 9px 21px -12px rgba(0, 0, 0, 0.88)');
    [...e.target.form.childNodes[childIndex].children].forEach(node => node.firstChild.style.background = '#fafafa');
    [...e.target.form.childNodes[childIndex].children].forEach(node => node.childNodes[0].childNodes[2].childNodes[3].innerText = 'Selecionar');

    e.target.previousElementSibling.offsetParent.offsetParent.style.transition = 'all 0.2s ease-in-out';
    e.target.previousElementSibling.offsetParent.offsetParent.style.boxShadow = '9px 9px 21px -12px rgba(0, 0, 255, 0.8)';
    e.target.previousElementSibling.offsetParent.offsetParent.style.transform = 'scale(1.2)';
    e.target.previousElementSibling.offsetParent.offsetParent.style.background = 'linear-gradient(90deg, rgba(0, 0, 255, 0.2) 0%, rgba(255, 0, 0, 0.2) 100%)';
    e.nativeEvent.target.innerText = 'Selecionado';

    setCipaVoto(e.target.value);
  };

  const confirmarCipa = async () => {
    setShowConfirmarCipaModal(false);
    setShowCipaJaVotouModal(true);
    setVotarCipa(false);

    const audio = new Audio('../../assets/som/confirma-urna.mp3');
    await audio.play();

    await criarCipa({ voto: cipaVoto });
    await getCipaJaVotou(email);

    setTimeout(() => {
      history.push('/');
    }, 5000);
  };

  const goToApuracao = () => {
    history.push('/cipa/apuracao');
  };

  const handleEquipamentoEngenhariaClinica = e => {
    setEquipamentoEngenhariaClinica(e.target.value);
  };

  useEffect(() => {
    if (isVestuario && subcategoria === 'Vestuário') {
      setMostrarVestuario(false);
    } else {
      setMostrarVestuario(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategoria]);

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true);

    const data = {
      email,
      nome,
      telefone,
      categoria,
      subcategoria,
      unidade,
      relato
    };

    if (subcategoria === 'ERP - (MXM)') {
      if (!erpNome) {
        setErpError('O campo Nome completo é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (!erpEmail) {
        setErpError('O campo e-mail é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (erpEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(erpEmail)) {
        setErpError('O e-mail digitado não é válido.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (!erpMatricula) {
        setErpError('O campo Matrícula é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (erpMatricula.replace(/\D/g, '').length !== 5) {
        setErpError('A matrícula digitada não é válida.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (!erpUnidade) {
        setErpError('O campo Unidade é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      const erp = {
        erpNome,
        erpEmail,
        erpMatricula,
        erpUnidade,
        erpAdministrador,
        erpCadastrosComuns,
        erpCadastrosComumFinanceiro,
        erpGestaoDeProcessos,
        erpCompras,
        erpContratoCompras,
        erpContasPagar,
        erpPagamentoEscritural,
        erpContasReceber,
        erpTesouraria,
        erpIntegracaoPadrao,
        erpContabil,
        erpEstoque,
        erpPatrimonio,
        erpOrcamento,
        erpReinf,
        erpEfd,
        erpEcd,
        erpEcf
      };

      data.erp = erp;
    }

    if (subcategoria === 'Formulário de Inscrição CIPAA') {
      if (!nome) {
        setCipaInscricaoError('O campo Nome completo é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!cipaInscricaoUnidade) {
        setCipaInscricaoError('O campo Unidade em que atua é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!cipaInscricaoCargo) {
        setCipaInscricaoError('O campo Cargo/Função é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!email) {
        setCipaInscricaoError('O campo e-mail é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setCipaInscricaoError('O e-mail digitado não é válido.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!matricula) {
        setCipaInscricaoError('O campo Matrícula é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (matricula.replace(/\D/g, '').length !== 5) {
        setCipaInscricaoError('A matrícula digitada não é válida.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!cipaInscricaoSobre) {
        setCipaInscricaoError('Marque o campo de confirmação de leitura do Edital.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      const cipaInscricao = {
        nome,
        unidade: cipaInscricaoUnidade,
        cargo: cipaInscricaoCargo,
        email,
        matricula,
        sobre: cipaInscricaoSobre
      };

      data.cipaInscricao = cipaInscricao;
    }

    if (subcategoria === 'Formulário de Criação') {
      if (!briefingPorque) {
        setBriefingError(<p>O campo <br /><br /> O que precisamos fazer? Por que você está fazendo esse pedido? <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingMedidas) {
        setBriefingError(<p>O campo <br /><br /> Quais peças devem ser desenvolvidas/criadas?Quais as medidas(largura X altura)? <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingOnde) {
        setBriefingError(<p>O campo <br /><br /> Onde serão veiculadas/expostas?(Redes sociais, portal, impressos, eventos etc.) <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingPrazo) {
        setBriefingError(<p>O campo <br /><br /> Qual é o prazo final para entrega do projeto? Sujeito a análise interna e viabilidade dos pedidos na fila de produção. <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (new Date(briefingPrazo) < Date.now()) {
        setBriefingError(<p>O campo <br /><br /> Qual é o prazo final para entrega do projeto? Sujeito a análise interna e viabilidade dos pedidos na fila de produção. <br /><br /> deve ser a partir de amanhã</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingDetalhe) {
        setBriefingError(<p>O campo <br /><br /> Tem mais algum detalhe?Deixe aqui o seu comentário para inspirar a nossa equipe. <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      const formData = new FormData();

      briefingArquivo1 && formData.append('files', briefingArquivo1);
      briefingArquivo2 && formData.append('files', briefingArquivo2);
      briefingArquivo3 && formData.append('files', briefingArquivo3);
      briefingArquivo4 && formData.append('files', briefingArquivo4);
      briefingArquivo5 && formData.append('files', briefingArquivo5);

      const response = await fetch(`${baseUrl}/ascom/upload`, {
        method: 'POST',
        headers: {
          // 'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      const files = await response.json();

      const briefing = {
        briefingPorque,
        briefingMedidas,
        briefingOnde,
        briefingPrazo,
        briefingDetalhe,
        briefingArquivos: files
      };

      data.relato = ' ';
      data.briefing = briefing;
    }

    if (subcategoria === 'Manutenção de Equipamentos') {
      if (!equipamentoEngenhariaClinica) {
        setEquipamentoEngenhariaClinicaError('Selecione um equipamento.');
        setShowEquipamentoEngenhariaClinicaModal(true);
        setLoading(false);

        return;
      }
    }

    if (subcategoria === 'Votação CIPAA') {
      if (!cipaVoto) {
        setCipaError('Selecione um candidato.');
        setShowCipaModal(true);
        setLoading(false);

        return;
      }

      setCipaFoto(cipaCards.find(item => item.nome === cipaVoto).foto);

      setShowConfirmarCipaModal(true);

      setLoading(false);

      return;
    }

    if (subcategoria === 'Vestuário') {
      if (!userMatricula) {
        setVestuarioError('Somente usuários com matrícula podem escolher o vestuário.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (isVestuario) {
        setVestuarioError('Você já escolheu os tamanhos do vestuário.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!camisa) {
        setVestuarioError('O campo Camisa é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!calca) {
        setVestuarioError('O campo Calça é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!jaleco) {
        setVestuarioError('O campo Jaleco é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!calcado) {
        setVestuarioError('O campo Calçado é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      setShowModalVestuarioConfirm(true);

      setLoading(false);

      return;
    }

    if (subcategoria === 'Vale refeição / alimentação') {
      if (!valeRefeicao) {
        setShowModalVRErro(true);
        setLoading(false);

        return;
      }

      if (valeRefeicao) {
        setShowModalVRConfirm(true);
      }

      setLoading(false);

      return;
    }

    if (categoria === 'Engenharia Clínica' && subcategoria === 'Manutenção de Equipamentos') {
      data.equipamentoEngenhariaClinica = equipamentoEngenhariaClinica;
    }

    if (categoria === 'Reposição de Material/Estoque' ||
      categoria === 'Férias' ||
      subcategoria === 'Formulário de Inscrição CIPAA' ||
      subcategoria === 'ERP - (MXM)') {
      data.relato = '...';
    }

    if (subcategoria === 'Solicitação de material de escritório') {
      for (let i = 0; i < materiaisEscritorio.length; i++) {
        if (materiaisEscritorio[i]['material'] === '') {
          setShowModal(true);
          setMaterialError('O campo Material de Escritório não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(materiaisEscritorio[i]['quantidade']) < 1) {
          setShowModal(true);
          setMaterialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }
      }

      data.materiaisEscritorio = materiaisEscritorio;
    }

    if (subcategoria === 'Solicitação de material de expediente') {
      for (let i = 0; i < materiaisExpediente.length; i++) {
        if (materiaisExpediente[i]['material'] === '') {
          setShowModal(true);
          setMaterialError('O campo Material de Expediente não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(materiaisExpediente[i]['quantidade']) < 1) {
          setShowModal(true);
          setMaterialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }
      }

      data.materiaisExpediente = materiaisExpediente;
    }

    if (subcategoria === 'Solicitação de material de limpeza') {
      for (let i = 0; i < materiaisLimpeza.length; i++) {
        if (materiaisLimpeza[i]['material'] === '') {
          setShowModal(true);
          setMaterialError('O campo Material de Limpeza não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(materiaisLimpeza[i]['quantidade']) < 1) {
          setShowModal(true);
          setMaterialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }
      }

      data.materiaisLimpeza = materiaisLimpeza;
    }

    if (subcategoria === 'Solicitação de transporte de pessoas') {
      if (solicitacaoVeiculo.veiculoData === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Data do transporte.');
        setLoading(false);

        return;
      }

      if (new Date(solicitacaoVeiculo.veiculoData) <= new Date()) {
        setShowModal(true);
        setVeiculoError('Não é possível agendar um veículo para uma data anterior ou igual a data atual.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoHora === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Hora do transporte.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoTempo === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Tempo estimado.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoPassageiro === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Nome do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoTelefone === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Telefone do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoSaida === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço da saída.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoDestino === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço do destino.');
        setLoading(false);

        return;
      }

      data.solicitacaoVeiculo = solicitacaoVeiculo;

      data.solicitacaoVeiculo.veiculoData = new Date(data.solicitacaoVeiculo.veiculoData);
    }

    if (subcategoria === 'Solicitação de transporte de materiais') {
      if (solicitacaoMotoboy.motoboyData === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Data do transporte.');
        setLoading(false);

        return;
      }

      if (new Date(solicitacaoMotoboy.motoboyData) <= new Date()) {
        setShowModal(true);
        setVeiculoError('Não é possível agendar um veículo para uma data anterior ou igual a data atual.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyHora === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Hora do transporte.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyTempo === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Tempo estimado.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyPassageiro === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Nome do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyTelefone === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Telefone do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboySaida === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço da saída.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyDestino === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço do destino.');
        setLoading(false);

        return;
      }

      data.solicitacaoMotoboy = solicitacaoMotoboy;

      data.solicitacaoMotoboy.motoboyData = new Date(data.solicitacaoMotoboy.motoboyData);
    }

    if (subcategoria === 'Criação de e-mail corporativo') {
      createEmail.registration = formatarMatricula(createEmail.registration);

      if (createEmail.registration === '') {
        setShowEmailModal(true);
        setEmailError('O campo Matrícula é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.registration.length !== 6) {
        setShowEmailModal(true);
        setEmailError('A Matrícula deve ter 5 números.');
        setLoading(false);

        return;
      }

      if (createEmail.name === '') {
        setShowEmailModal(true);
        setEmailError('O campo Nome é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.email === '') {
        setShowEmailModal(true);
        setEmailError('O campo E-mail sugerido é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.phone === '') {
        setShowEmailModal(true);
        setEmailError('O campo Telefone é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.admissionDate === '') {
        setShowEmailModal(true);
        setEmailError('O campo Data de admissão é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.unit === '') {
        setShowEmailModal(true);
        setEmailError('O campo Unidade é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.job === '') {
        setShowEmailModal(true);
        setEmailError('O campo Cargo é obrigatório.');
        setLoading(false);

        return;
      }

      const dataCriacaoEmail = {
        registration: createEmail.registration,
        name: createEmail.name,
        email: createEmail.email,
        phone: createEmail.phone,
        admissionDate: new Date(createEmail.admissionDate),
        unit: createEmail.unit,
        job: createEmail.job,
        sisged: createEmail.sisged
      };

      data.criacaoEmail = dataCriacaoEmail;
    }

    if (subcategoria === 'Sistemas de Saúde') {
      if (!loginSuporte?.tipo) {
        setLoginSistemasError('O campo Login ou Suporte é obrigatório.');
        setShowLoginSistemasModal(true);
        setLoading(false);

        return;
      }

      if (!loginSistemas) {
        setLoginSistemasError('O campo Sistema é obrigatório.');
        setShowLoginSistemasModal(true);
        setLoading(false);

        return;
      }

      const notValidate = (loginSistemas !== 'CNES' && loginSistemas !== 'BPA' && loginSistemas !== 'RAAS' && loginSistemas !== 'Outros');

      if (loginSuporte?.tipo === 'login') {
        if (notValidate && !loginSuporte?.unidade) {
          setLoginSistemasError('O campo Unidade é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.nome) {
          setLoginSistemasError('O campo Nome Completo é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.cpf) {
          setLoginSistemasError('O campo CPF é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && cpfValidator(loginSuporte?.cpf)?.error) {
          setLoginSistemasError(cpfValidator(loginSuporte?.cpf)?.message);
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.cns) {
          setLoginSistemasError('O campo CNS é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !cnsValidator(loginSuporte?.cns)) {
          setLoginSistemasError('O CNS digitado não é válido.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.email) {
          setLoginSistemasError('O campo e-mail é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !emailValidator(loginSuporte?.email)) {
          setLoginSistemasError('O e-mail digitado não é válido.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.telefone) {
          setLoginSistemasError('O campo Telefone é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        const dataLoginSistemas = {
          tipo: loginSuporte?.tipo ? loginSuporte?.tipo : '',
          sistema: loginSistemas ? loginSistemas : '',
          unidade: loginSuporte?.unidade ? loginSuporte?.unidade : '',
          nome: loginSuporte?.nome ? loginSuporte?.nome : '',
          cpf: loginSuporte?.cpf ? cpfMask(loginSuporte?.cpf) : '',
          cns: loginSuporte?.cns ? loginSuporte?.cns : '',
          email: loginSuporte?.email ? loginSuporte?.email : '',
          telefone: loginSuporte?.telefone ? phoneMask(loginSuporte?.telefone) : ''
        };

        data.loginSistemas = dataLoginSistemas;
      }

      if (loginSuporte?.tipo === 'suporte') {
        const suporteFormData = new FormData();

        suporteArquivo1 && suporteFormData.append('files', suporteArquivo1);
        suporteArquivo2 && suporteFormData.append('files', suporteArquivo2);
        suporteArquivo3 && suporteFormData.append('files', suporteArquivo3);
        suporteArquivo4 && suporteFormData.append('files', suporteArquivo4);
        suporteArquivo5 && suporteFormData.append('files', suporteArquivo5);

        const response = await fetch(`${baseUrl}/suporte/upload`, {
          method: 'POST',
          headers: {
            // 'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: suporteFormData
        });

        const filesSuporte = await response.json();

        const dataLoginSistemas = {
          tipo: loginSuporte?.tipo,
          sistema: loginSistemas,
          suporteArquivos: filesSuporte
        };

        data.loginSistemas = dataLoginSistemas;
      }
    }

    if (subcategoria === 'Ponto Eletrônico') {
      if (!pontoEletronico) {
        setRelatoError('O campo Assunto é obrigatório');
        setShowRelatoModal(true);
        setLoading(false);

        return;
      }

      data.pontoEletronico = {
        assunto: pontoEletronico,
      };
    }

    const categoriasExcluidas = [
      'Manutenção de rede/internet',
      'Manutenção VOIP (Telefone Fixo)'
    ];

    if (categoria === 'Suporte de TI') {
      if (subcategoria.includes('Manutenção') && !categoriasExcluidas.includes(subcategoria)) {
        if (!patrimonioTi) {
          setTiError('O campo Patrimônio é obrigatório.');
          setShowTiModal(true);
          setLoading(false);
  
          return;
        }
      }

      data.suporteTi = {
        telContatoTi,
        patrimonioTi,
        empresaResp: ''
      };
    }

    if (data.relato === '' && subcategoria !== 'Criação de e-mail corporativo') {
      setShowRelatoModal(true);
      setRelatoError('Descreva a solicitação.');
      setLoading(false);

      return;
    }

    const sla = categorias
      .filter(item => item.categoria === categoria)[0].subcategoria
      .filter(item => item.nome === subcategoria)[0].sla;

    const responder = categorias
      .filter(item => item.categoria === categoria)[0].subcategoria
      .filter(item => item.nome === subcategoria)[0].responder;

    data.createdAt = new Date();
    data.sla = sla;
    data.status = 'Aberto';
    data.responder = responder;

    if (subcategoria === 'Formulário de Inscrição CIPAA') {
      getCipaInscricao(email);
    }

    criarChamado(data);

    setLoading(false);

    history.push({
      pathname: '/solicitacoes',
      state: { isRedirect: true }
    });
  };

  return (
    <Container className={styles.container}>
      <Row className={styles.title}>Nova Solicitação</Row>
      <Form onSubmit={handleSubmit} noValidate >
        {usuario && (
          <>
            <Form.Group controlId="formEmail" className="mt-4">
              <Form.Label>*e-mail:</Form.Label>
              <Form.Control
                type="email"
                required
                name="formEmail"
                onChange={e => handleEmail(e)}
                value={userEmail}
                readOnly />
            </Form.Group>

            <Row>
              <Col sm={7}>
                <Form.Group controlId="formNome" className="mt-4">
                  <Form.Label>*Nome do Solicitante:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="formNome"
                    onChange={e => handleNome(e)}
                    value={userNome}
                  />
                </Form.Group>
              </Col>

              <Col sm={5}>
                <Form.Group controlId="formTelefone" className="mt-4">
                  <Form.Label>*Telefone:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="formTelefone"
                    onChange={e => handleTelefone(e)}
                    value={userTelefone}
                    placeholder="(21) 99999-9999"
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}

        {!isConsulta && (
          <Row>
            <Col>
              <Unidades
                handleUnidade={handleUnidade}
                getUnidades={unidades}
                userUnidade={userUnidade}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            {unidade && (
              <Categorias
                handleCategoria={handleCategoria}
                getCategorias={categorias}
              />
            )}
          </Col>

          <Col>
            {categoria === 'Suporte de TI' && (
              <SuporteTi
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                unidade={unidade}
              />
            )}

            {categoria === 'Manutenção Predial' && (
              <ManutencaoPredial
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Elétrica e Iluminação' && (
              <Eletrica
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Água e Esgoto' && (
              <Hidrossanitario
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Ar-Condicionado' && (
              <Mecanica
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Equipamentos e Mobiliários' && (
              <ManutencaoEquip
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Reposição de Material/Estoque' && (
              <Reposicao
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Agendamento de Veículo' && (
              <Veiculo
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                unidade={unidade}
              />
            )}

            {categoria === 'Demonstrativos' && (
              <Demonstrativos
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Cadastro' && (
              <Cadastro
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Eleição' && (
              <Votacao
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Engenharia Clínica' && (
              <EngenhariaClinica
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Solicitações ASCOM' && (
              <Ascom
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Sistemas Administrativos - Criação de Login/Suporte' && (
              <SuporteSistemas
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Solicitações de Ponto Eletrônico' && (
                <PontoEletronico
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}
          </Col>
        </Row>

        {subcategoria === 'Criação de e-mail corporativo' && (
          <Email
            handleCreateEmail={handleCreateEmail}
            unidades={unidades}
            showEmailModal={showEmailModal}
            closeEmailModal={closeEmailModal}
            emailError={emailError}
            createEmail={createEmail}
          />
        )}

        {subcategoria === 'Sistemas de Saúde' && (
          <LoginSistemas
            handleLoginSistemas={handleLoginSistemas}
            loginSistemas={loginSistemas}
            showLoginSistemasModal={showLoginSistemasModal}
            loginSistemasError={loginSistemasError}
            handleLoginSistemasModalClose={handleLoginSistemasModalClose}
            loginSuporte={loginSuporte}
            handleLoginSuporte={handleLoginSuporte}
            unidadesSistema={unidadesPesquisa}
            handleSuporteArquivo={handleSuporteArquivo}
            suporteArquivo1={suporteArquivo1}
            suporteArquivo2={suporteArquivo2}
            suporteArquivo3={suporteArquivo3}
            suporteArquivo4={suporteArquivo4}
            suporteArquivo5={suporteArquivo5}
            resetSuporteArquivo={resetSuporteArquivo}
            showSuporteModal={showSuporteModal}
            handleSuporteModalClose={handleSuporteModalClose}
            suporteError={suporteError}
          />
        )}

        {subcategoria === 'Solicitação de medicamentos' && (
          <>
            <MedicamentosSaudeMental
              medicamentosSaudeMental={medicamentosSaudeMental}
              listaSaudeMental={listaSaudeMental}
              handleModalShow={handleModalShow}
              showModal={showModal}
              handleModalClose={handleModalClose}
              handleRemoveMedicamentoSaudeMental={handleRemoveMedicamentoSaudeMental}
              handleAddMedicamentoSaudeMental={handleAddMedicamentoSaudeMental}
              handleMedicamentosSaudeMental={handleMedicamentosSaudeMental}
              handleSwitch={handleSwitch}
            />

            {showMedicamentosAtencaoBasica && (
              <MedicamentosAtencaoBasica
                medicamentosAtencaoBasica={medicamentosAtencaoBasica}
                listaAtencaoBasica={listaAtencaoBasica}
                handleModalShow={handleModalShow}
                showModal={showModal}
                handleModalClose={handleModalClose}
                handleRemoveMedicamentoAtrequiredencaoBasica={handleRemoveMedicamentoAtencaoBasica}
                handleAddMedicamentoAtencaoBasica={handleAddMedicamentoAtencaoBasica}
                handleMedicamentosAtencaoBasica={handleMedicamentosAtencaoBasica}
              />
            )}
          </>
        )}

        {subcategoria === 'Solicitação de material de escritório' && (
          <MateriaisEscritorio
            materiaisEscritorio={materiaisEscritorio}
            listaMateriaisEscritorio={listaMateriaisEscritorio}
            handleMateriaisEscritorio={handleMateriaisEscritorio}
            handleRemoveMateriaisEscritorio={handleRemoveMateriaisEscritorio}
            handleAddMateriaisEscritorio={handleAddMateriaisEscritorio}
            showModal={showModal}
            handleModalClose={handleModalClose}
            materialError={materialError}
          />
        )}

        {subcategoria === 'Solicitação de material de expediente' && (
          <MateriaisExpediente
            materiaisExpediente={materiaisExpediente}
            listaMateriaisExpediente={listaMateriaisExpediente}
            handleMateriaisExpediente={handleMateriaisExpediente}
            handleRemoveMateriaisExpediente={handleRemoveMateriaisExpediente}
            handleAddMateriaisExpediente={handleAddMateriaisExpediente}
            showModal={showModal}
            handleModalClose={handleModalClose}
            materialError={materialError}
          />
        )}

        {subcategoria === 'Solicitação de material de limpeza' && (
          <MateriaisLimpeza
            materiaisLimpeza={materiaisLimpeza}
            listaMateriaisLimpeza={listaMateriaisLimpeza}
            handleMateriaisLimpeza={handleMateriaisLimpeza}
            handleRemoveMateriaisLimpeza={handleRemoveMateriaisLimpeza}
            handleAddMateriaisLimpeza={handleAddMateriaisLimpeza}
            showModal={showModal}
            handleModalClose={handleModalClose}
            materialError={materialError}
          />
        )}

        {subcategoria === 'Solicitação de transporte de pessoas' && (
          <SolicitacaoVeiculo
            handleSolicitacaoVeiculo={handleSolicitacaoVeiculo}
            veiculoTempo={solicitacaoVeiculo.veiculoTempo}
            showModal={showModal}
            handleModalClose={handleModalClose}
            veiculoError={veiculoError}
          />
        )}

        {subcategoria === 'Solicitação de transporte de materiais' && (
          <SolicitacaoMotoboy
            handleSolicitacaoMotoboy={handleSolicitacaoMotoboy}
            motoboyTempo={solicitacaoMotoboy.motoboyTempo}
            showModal={showModal}
            handleModalClose={handleModalClose}
            veiculoError={veiculoError}
          />
        )}

        {subcategoria === 'Vale refeição / alimentação' && (
          <ValeRefeicao
            handleValeRefeicao={handleValeRefeicao}
            showModalVRErro={showModalVRErro}
            handleModalVRErroClose={handleModalVRErroClose}
            showModalVRConfirm={showModalVRConfirm}
            handleModalVRConfirmClose={handleModalVRConfirmClose}
            vrOption={vrOption}
            vrConfirm={vrConfirm}
            isValeRefeicao={isValeRefeicao}
          />
        )}

        {subcategoria === 'Vestuário' && (
          <Vestuario
            handleCalcado={handleCalcado}
            calcado={calcado}
            numeroCalcado={numeroCalcado}
            showVestuarioModal={showVestuarioModal}
            handleVestuarioModalClose={handleVestuarioModalClose}
            vestuarioError={vestuarioError}
            handleCamisa={handleCamisa}
            camisa={camisa}
            handleCalca={handleCalca}
            calca={calca}
            handleJaleco={handleJaleco}
            jaleco={jaleco}
            handleVestuarioObservacoes={handleVestuarioObservacoes}
            vestuarioObservacoes={vestuarioObservacoes}
            showModalVestuarioConfirm={showModalVestuarioConfirm}
            handleModalVestuarioConfirmClose={handleModalVestuarioConfirmClose}
            showVestuarioMessageModal={showVestuarioMessageModal}
            handleVestuarioMessageModalClose={handleVestuarioMessageModalClose}
            isVestuario={isVestuario}
            vestuarioConfirm={vestuarioConfirm}
          />
        )}

        {subcategoria === 'Manutenção de Equipamentos' && (
          <ManutencaoEquipamentos
            handleEquipamentoEngenhariaClinica={handleEquipamentoEngenhariaClinica}
            equipamentoEngenhariaClinica={equipamentoEngenhariaClinica}
            equipamentosEngenhariaClinica={equipamentosEngenhariaClinica}
          />
        )}

        {!isErp && subcategoria === 'ERP - (MXM)' && (
          <Alert variant="primary" className="mt-4">
            <Alert.Heading>Atenção!</Alert.Heading>
            <p>
              O seu Perfil não tem permissão para acessar esse módulo.
            </p>
            <p>
              Solicite a sua permissão em admusu@fesaude.niteroi.rj.gov.br
            </p>
          </Alert>
        )}

        {isErp && subcategoria === 'ERP - (MXM)' && (
          <Erp
            erpNome={erpNome}
            handleErpNome={handleErpNome}
            erpEmail={erpEmail}
            handleErpEmail={handleErpEmail}
            erpMatricula={erpMatricula}
            handleErpMatricula={handleErpMatricula}
            erpUnidade={erpUnidade}
            handleErpUnidade={handleErpUnidade}
            erpAdministrador={erpAdministrador}
            handleErpAdministrador={handleErpAdministrador}
            handleErpCadastrosComuns={handleErpCadastrosComuns}
            erpCadastrosComuns={erpCadastrosComuns}
            handleErpCadastrosComumFinanceiro={handleErpCadastrosComumFinanceiro}
            erpCadastrosComumFinanceiro={erpCadastrosComumFinanceiro}
            handleErpGestaoDeProcessos={handleErpGestaoDeProcessos}
            erpGestaoDeProcessos={erpGestaoDeProcessos}
            handleErpCompras={handleErpCompras}
            erpCompras={erpCompras}
            handleErpContratoCompras={handleErpContratoCompras}
            erpContratoCompras={erpContratoCompras}
            handleErpContasPagar={handleErpContasPagar}
            erpContasPagar={erpContasPagar}
            handleErpPagamentoEscritural={handleErpPagamentoEscritural}
            erpPagamentoEscritural={erpPagamentoEscritural}
            handleErpContasReceber={handleErpContasReceber}
            erpContasReceber={erpContasReceber}
            handleErpTesouraria={handleErpTesouraria}
            erpTesouraria={erpTesouraria}
            handleErpIntegracaoPadrao={handleErpIntegracaoPadrao}
            erpIntegracaoPadrao={erpIntegracaoPadrao}
            handleErpContabil={handleErpContabil}
            erpContabil={erpContabil}
            handleErpEstoque={handleErpEstoque}
            erpEstoque={erpEstoque}
            handleErpPatrimonio={handleErpPatrimonio}
            erpPatrimonio={erpPatrimonio}
            handleErpOrcamento={handleErpOrcamento}
            erpOrcamento={erpOrcamento}
            handleErpReinf={handleErpReinf}
            erpReinf={erpReinf}
            handleErpEfd={handleErpEfd}
            erpEfd={erpEfd}
            handleErpEcd={handleErpEcd}
            erpEcd={erpEcd}
            handleErpEcf={handleErpEcf}
            erpEcf={erpEcf}
            showErpModal={showErpModal}
            handleErpModalClose={handleErpModalClose}
            erpError={erpError}
          />
        )}

        {subcategoria === 'Formulário de Criação' && (
          <Briefing
            handleBriefingPorque={handleBriefingPorque}
            handleBriefingMedidas={handleBriefingMedidas}
            handleBriefingOnde={handleBriefingOnde}
            handleBriefingPrazo={handleBriefingPrazo}
            handleBriefingDetalhe={handleBriefingDetalhe}
            resetBriefingArquivo={resetBriefingArquivo}
            briefingArquivo1={briefingArquivo1}
            briefingArquivo2={briefingArquivo2}
            briefingArquivo3={briefingArquivo3}
            briefingArquivo4={briefingArquivo4}
            briefingArquivo5={briefingArquivo5}
            showBriefingModal={showBriefingModal}
            handleBriefingModalClose={handleBriefingModalClose}
            briefingError={briefingError}
            handleBriefingArquivo={handleBriefingArquivo}
          />
        )}

        {subcategoria === 'Ponto Eletrônico' && (
          <Form.Group className='mt-3'>
            <Form.Label>Assunto:</Form.Label>
            <Form.Select
              className="border border-secondary"
              required
              name="pontoEletronico"
              value={pontoEletronico}
              onChange={handlePontoEletronico}
            >
              <option value="">Selecione o assunto</option>
              {pontoEletronicoSelect.map(item => (
                <option key={item} value={item}>{item}</option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {subcategoria === 'Formulário de Inscrição CIPAA' && prazoInscricao && !cipaInscricao.inscrito && (
          <CipaInscricao
            handleCipaInscricaoUnidade={handleCipaInscricaoUnidade}
            cipaInscricaoUnidade={cipaInscricaoUnidade}
            handleCipaInscricaoCargo={handleCipaInscricaoCargo}
            cipaInscricaoCargo={cipaInscricaoCargo}
            handleCipaInscricaoSobre={handleCipaInscricaoSobre}
            showCipaInscricaoModal={showCipaInscricaoModal}
            handleCipaInscricaoModalClose={handleCipaInscricaoModalClose}
            cipaInscricaoError={cipaInscricaoError}
            nome={nome}
            email={email}
            matricula={matricula}
          />
        )}

        {subcategoria === 'Formulário de Inscrição CIPAA' && !prazoInscricao && (
          <Alert variant="warning" className="mt-4">
            <Alert.Heading>Atenção</Alert.Heading>
            <p>
              O prazo da Inscrição para a Eleição da CIPAA já terminou.
            </p>
          </Alert>
        )}

        {subcategoria === 'Formulário de Inscrição CIPAA' && cipaInscricao?.inscrito && (
          <>
            <Row className={styles.cipa_ja_votou}>Você já se inscreveu em {cipaInscricao?.createdAt ? formatarDataEHora(cipaInscricao?.createdAt) : ''}</Row>

            <div className={styles.title_cipa_container}>
              <div className={styles.cipa_title}>
                Formulário de Inscrição CIPAA
              </div>
            </div>
          </>
        )}

        {(subcategoria === 'Votação CIPAA' && !matricula && (
          <Alert variant='warning' className='mt-4'>
            Somente colaboradores com matrícula estão habilitados a participarem da votação
          </Alert>
        ))}

        {subcategoria === 'Votação CIPAA' && !prazoInscricao && (
          <Alert variant="warning" className="mt-4">
            <Alert.Heading>Atenção</Alert.Heading>
            <p>
              O prazo da Votação para a Eleição da CIPAA já terminou.
            </p>
          </Alert>
        )}

        {(subcategoria === 'Votação CIPAA' && !cipaJaVotou?.jaVotou && matricula && prazoVotacao) && (
          <>
            <div className={styles.title_cipa_container}>
              <div className={styles.cipa_title}>
                CIPAA - Comissão Interna de Prevenção de Acidentes e de Assédio
              </div>

              <Alert variant="primary" className="mt-4">
                <Alert.Heading>Atenção!</Alert.Heading>
                <p>
                  Escolha seu candidato, clique em Selecionar e no botão <span className='text-uppercase'>Votar</span> abaixo para confirmar seu voto.
                </p>
              </Alert>
            </div>

            <div className={styles.cipa_container}>
              {cipaCards.sort((a, b) => {
                if (a.nome > b.nome) {
                  return 1;
                } else if (a.nome < b.nome) {
                  return -1;
                } else {
                  return 0;
                }
              }).map(cipaCard => {
                return (
                  <Cipa
                    key={cipaCard.id}
                    foto={cipaCard.foto}
                    nome={cipaCard.nome}
                    lotacao={cipaCard.lotacao}
                    funcao={cipaCard.funcao}
                    selecionarCipa={e => selecionarCipa(e)}
                  />
                );
              })}
            </div>

            <Modal show={showCipaModal} onHide={handleCipaModalClose}>
              <Modal.Header closeButton>
                <Modal.Title>Erro</Modal.Title>
              </Modal.Header>
              <Modal.Body>{cipaError}</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCipaModalClose}>
                  Fechar
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={showConfirmarCipaModal} onHide={handleConfirmarCipaModalClose}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmar</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ textAlign: 'center' }}>Tem certeza que deseja confirmar o voto em:</Modal.Body>
              <Modal.Body className={styles.modal_nome}>
                <img src={cipaFoto} alt="Foto candidato" className={styles.card_photo} />
                {cipaVoto}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="warning" className={styles.corrige} onClick={handleConfirmarCipaModalClose}>
                  Corrige
                </Button>
                <Image
                  width={116}
                  height={85}
                  src="../../assets/img/cipa/confirma.jpeg"
                  fluid
                  onClick={confirmarCipa}
                  className={styles.confirma}
                />
              </Modal.Footer>
            </Modal>

            <Modal show={showCipaJaVotouModal} onHide={handleCipaJaVotouModalClose}>
              <Modal.Header closeButton>
                <Modal.Title>Sucesso</Modal.Title>
              </Modal.Header>
              <Modal.Body>O seu voto foi registrado com sucesso!</Modal.Body>
              <Modal.Footer>Redirecionando para a Home...</Modal.Footer>
            </Modal>
          </>
        )}

        {subcategoria === 'Votação CIPAA' && cipaJaVotou?.jaVotou && (
          <>
            <Row className={styles.cipa_ja_votou}>Você já votou em {formatarDataEHora(cipaJaVotou?.createdAt)}</Row>

            <div className={styles.title_cipa_container}>
              <div className={styles.cipa_title}>
                CIPAA - Comissão Interna de Prevenção de Acidentes e de Assédio
              </div>

              {isAdmin && (
                <>
                  {/* <Button variant="primary" className={styles.button_list} onClick={cipaApuracao}>
                    <FaFileAlt className={styles.icon_list} /> Listagem
                  </Button> */}

                  <Button variant="primary" className={styles.button_list} onClick={goToApuracao}>
                    <FaFileAlt className={styles.icon_list} /> Apuração
                  </Button>
                </>
              )}
            </div>

            {/* <div className={styles.cipa_container}>
              {cipaCards.map(cipaCard => {
                return (
                  <Cipa
                    key={cipaCard.id}
                    foto={cipaCard.foto}
                    nome={cipaCard.nome}
                    lotacao={cipaCard.lotacao}
                    funcao={cipaCard.funcao}
                    selecionarCipa={selecionarCipa}
                    buttonCipaDisabled={true}
                  />
                );
              })}
            </div> */}
          </>
        )}

        <Modal show={showEquipamentoEngenhariaClinicaModal} onHide={handleEquipamentoEngenhariaClinicaModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Erro</Modal.Title>
          </Modal.Header>
          <Modal.Body>{equipamentoEngenhariaClinicaError}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleEquipamentoEngenhariaClinicaModalClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        {subcategoria === 'Apuração CIPAA' && history.push('/cipa/apuracao')}

        <div aria-live="polite" aria-atomic="true" className={styles.toast}>
          <ToastContainer position="bottom-center">
            <Toast
              onClose={() => setShowVestuarioToast(false)}
              show={showVestuarioToast}
              delay={5000}
              autohide
              bg="primary"
            >
              <Toast.Header style={{ backgroundColor: "#80deea" }}>
                <strong className="me-auto" style={{ color: "#000" }}>Sucesso</strong>
              </Toast.Header>
              <Toast.Body className={styles.toastBody}>A sua escolha foi gravada com sucesso!</Toast.Body>
            </Toast>
          </ToastContainer>
        </div>

        {
          (categoria === 'Manutenção Predial' || categoria === 'Manutenção de Elétrica e Iluminação' || categoria === 'Manutenção de Água e Esgoto' || categoria === 'Manutenção de Ar-Condicionado') && subcategoria && (
            <Container>
              <Row>
                <p className={styles.manutencao_title}>
                  Em caso de emergência ou agravamento ligue para (21) 97029-6574
                </p>
              </Row>
              <Row style={{ position: 'relative' }}>
                <p className={styles.manutencao_subtitle}>
                  Favor detalhar a solicitação no campo abaixo, informando: ambiente(s), quantidade(s), etc.
                </p>
              </Row>
            </Container>
          )
        }

        {categoria === 'Suporte de TI' && (
          <SuporteTiForm
            handleTelContatoTi={handleTelContatoTi}
            telContatoTi={telContatoTi}
            subcategoria={subcategoria}
            handlePatrimonioTi={handlePatrimonioTi}
            patrimonioTi={patrimonioTi}
            showTiModal={showTiModal}
            handleTiModalClose={handleTiModalClose}
            tiError={tiError}
          />
        )}

        <Row>
          {subcategoria && subcategoria !== 'ERP - (MXM)' && categoria !== 'Demonstrativos' && categoria !== 'Cadastro' && categoria !== 'Eleição' && categoria !== 'Solicitações ASCOM' && (
            <Relato
              handleRelato={handleRelato}
              counter={counter}
              isRequired={isRequired}
              mensagemRelato={mensagemRelato}
              showRelatoModal={showRelatoModal}
              handleRelatoModalClose={handleRelatoModalClose}
              relatoError={relatoError}
            />
          )}
        </Row>

        {(subcategoria !== 'Vale refeição / alimentação' && subcategoria !== 'Votação CIPAA') && mostrarVestuario && (subcategoria !== 'Formulário de Inscrição CIPAA' || !cipaInscricao?.inscrito) && !loading && (
          <div className="text-center mt-4">
            {subcategoria && (
              <Button variant="flat" className={styles.save_btn} type="submit">
                Enviar
              </Button>
            )}
          </div>
        )}

        {subcategoria === 'Votação CIPAA' && prazoVotacao && !cipaJaVotou?.jaVotou && !loading && (
          <div className="text-center mt-4">
            {subcategoria && (
              <Button
                variant="flat"
                className={styles.save_btn}
                disabled={!votarCipa}
                type="submit"
              >
                VOTAR
              </Button>
            )}
          </div>
        )}

        {loading && (
          <div className="text-center mt-4">
            {subcategoria && (
              <Button variant="flat" className={styles.save_btn} type="submit" disabled>
                Enviando...
              </Button>
            )}
          </div>
        )}

      </Form>
    </Container>
  );
};

export default ChamadosNovo;
